// components/ShareModal.js
import { NormalButton, NormalInput, TableWrapper } from "component/common";
import React, { Component } from "react";
import closeIcon from "assets/images/close.png";
import {
  commonDeleteBackendApi,
  getBackendCommonApi,
  updateCommon,
} from "redux/actions/Backend";
import {
  commonCreateApi,
  commonDeleteApi,
  commonPatchApi,
  commonUpdateApi,
  getCommonApi,
} from "redux/actions/common";
import { Toast } from "service/toast";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { bindActionCreators } from "redux";

export class ShareModalClass extends Component {
  state = {
    shareCustomer: "",
    shareVisible: false,
    storeShareCustomer: {},
    sharedCustomerList: [],
    customerOption: [],
    shareHeaderDetails: [{ label: "Name" }, { label: "Phone" }, { label: "" }],
  };

  componentDidMount() {
    if (this.props.selectedPackage) {
      this.handleGetSharedPackages();
    }
  }

  //   componentDidUpdate(prevProps) {
  //     if (
  //       this.props.selectedPackage?.id !== prevProps.selectedPackage?.id &&
  //       this.props.selectedPackage?.id
  //     ) {
  //       this.handleGetSharedPackages();
  //     }
  //   }

  handleSearchCustomer = (text) => {
    let { shareCustomer } = this.state;
    shareCustomer = text ?? "";
    this.setState({ shareCustomer });
  };

  handleShareIconSearch = async () => {
    let { shareCustomer } = this.state;
    // this.setState((prevState) => ({
    //   visible: !prevState.visible,
    // }));
    await this.setState({ shareVisible: true });
    let data = shareCustomer ?? "";
    await this.search(data);
  };

  handleShareCheckIn = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleShareIconSearch();
    }
  };

  handleSelectShareCustomer = (data) => {
    const newCustomer = {
      name: data?.cust_name,
      phone: data?.cust_phone2,
      id: data?.id,
    };

    this.setState({
      shareCustomer: data?.cust_name,
      storeShareCustomer: newCustomer,
      shareVisible: false,
    });
  };

  handleSharePackage = () => {
    const { sharedCustomerList, storeShareCustomer } = this.state;
    const { selectedPackage } = this.props;
    const isAlreadyShared = sharedCustomerList.some((customer) =>
      customer.customer_id
        ? customer.customer_id === storeShareCustomer?.id
        : customer.id === storeShareCustomer?.id
    );
    if (isAlreadyShared) {
      Toast({
        type: "error",
        message: "Customer already added to shared list.",
      });
      return;
    }

    const isInCartList = selectedPackage?.cust_noid === storeShareCustomer?.id;
    if (isInCartList) {
      Toast({ type: "error", message: "Customer already found in cart list." });
      return;
    }

    const newCustomer = { ...storeShareCustomer };

    this.setState((prevState) => ({
      sharedCustomerList: [...prevState.sharedCustomerList, newCustomer],
    }));
  };

  handleSharePackageConfirm = () => {
    let { sharedCustomerList } = this.state;
    let { selectedPackage } = this.props;
    let payload = sharedCustomerList
      ?.filter((list) => !list?.customer_id)
      ?.map((item) => ({
        itemcart_id: selectedPackage?.id,
        customer_id: item?.id,
        customerName: item?.name,
        customerPhone: item?.phone,
        ...(selectedPackage?.shareId && { share_id: selectedPackage.shareId }),
      }));
    this.props.updateCommon("ItemCartCustomersShareds", payload).then((res) => {
      this.props.handleClose();
      this.setState({
        sharedCustomerList: [],
        shareCustomer: "",
      });
    });
  };

  handleDeleteSharePackage = (list) => {
    let { sharedCustomerList } = this.state;
    console.log(list, "list");
    if (list?.customer_id) {
      this.props
        .commonDeleteBackendApi(`ItemCartCustomersShareds/${list?.id}`)
        .then((res) => {
          const updatedList = sharedCustomerList.filter(
            (item) => item.id !== list.id
          );
          this.setState({ sharedCustomerList: updatedList });
        })
        .catch((err) => {
          console.log(err, "Error");
        });
    } else {
      const updatedList = sharedCustomerList.filter(
        (item) => item.id !== list.id
      );
      this.setState({ sharedCustomerList: updatedList });
    }
  };

  handleGetSharedPackages = () => {
    let { selectedPackage } = this.props;
//      `ItemCartCustomersShareds/?filter=%7B%22where%22%3A%7B%22itemcart_id%22%3A%22${selectedPackage?.id}%20%22%7D%7D`
//        `ItemCartCustomersShareds/?filter=%7B%22where%22%3A%20%7B%22and%22%3A%20%5B%7B%22itemcart_id%22%3A%20%22${selectedPackage?.id}%22%7D%2C%20%7B%22share_id%22%3A%20%22${selectedPackage?.shareId}%22%7D%5D%20%7D%20%20%7D`

    if (selectedPackage?.shareId)
    {
      this.props
      .getBackendCommonApi(
        `ItemCartCustomersShareds/?filter=%7B%22where%22%3A%7B%22and%22%3A%5B%7B%22itemcart_id%22%3A${selectedPackage?.id}%7D%2C%7B%22or%22%3A%5B%7B%22share_id%22%3A${selectedPackage?.shareId}%7D%2C%7B%22share_id%22%3Anull%7D%5D%7D%5D%7D%7D`
      )
      .then((res) => {
        console.log(res, "Reponse");
        let customerList = res?.map((list) => ({
          ...list,
          name: list?.customerName,
          phone: list?.customerPhone,
        }));
        this.setState({
          sharedCustomerList: customerList,
        });
      });
    } else {
      this.props
      .getBackendCommonApi(
      `ItemCartCustomersShareds/?filter=%7B%22where%22%3A%7B%22itemcart_id%22%3A%22${selectedPackage?.id}%20%22%7D%7D`
      )
      .then((res) => {
        console.log(res, "Reponse");
        let customerList = res?.map((list) => ({
          ...list,
          name: list?.customerName,
          phone: list?.customerPhone,
        }));
        this.setState({
          sharedCustomerList: customerList,
        });
      });

    }

  };

  search = (searchString) => {
    let { formFields } = this.state;
    // if (
    //   searchString == "" ||
    //   (searchString && String(searchString).length >= 3)
    // ) {
    this.props
      .getCommonApi(`custappt/?search=${searchString}`)
      .then(async (key) => {
        let { status, data } = key;

        if (status === 200) {
          // for (let value of data) {
          //     customerList.push({ value: value.id, label: value.emp_name })
          // }

          await this.setState({ customerOption: data });

          //this.setState({ cartId: "" }); //Yoonus
        }
      });
    //}
  };

  render() {
    const {
      shareCustomer,
      shareVisible,
      sharedCustomerList,
      shareHeaderDetails,
      customerOption,
    } = this.state;
    const { selectedPackage, t } = this.props;
    return (
      <div className="share-modal">
        <h5>
          Share this {selectedPackage?.item_desc} with the following customers:
        </h5>
        <div className="d-flex col-12">
          <div className="col-8 d-flex flex-wrap mt-4">
            <div className="col-6 mr-3">
              <NormalInput
                placeholder="Search Customer...."
                value={shareCustomer}
                name="custName"
                onChange={(e) => this.handleSearchCustomer(e.target.value)}
                onKeyDown={this.handleShareCheckIn}
                iconsVisible
                onClickIcon={() => {
                  this.handleShareIconSearch();
                }}
              />
            </div>

            <NormalButton
              onClick={this.handleSharePackage}
              label="Share"
              mainbg={true}
              className=""
            />
            {shareVisible ? (
              <div className="col-12">
                <div
                  className="customerSearch-block"
                  style={{ position: "relative" }}
                >
                  <div className="closeIconParent">
                    <img
                      onClick={() => this.setState({ shareVisible: false })}
                      className="close cursor-pointer close-flexEnd"
                      src={closeIcon}
                      alt=""
                    />
                  </div>
                  <div className="d-flex mt-4 table table-header w-100 m-0">
                    <div className="col-2">{t("Name")}</div>
                    <div className="col-2">{t("Phone")}</div>
                    <div className="col-1">{t("Site")}</div>
                    <div className="col-2">{t("Cust Code")}</div>
                    <div className="col-2">{t("Reference")}</div>
                    <div className="col-3">{t("Email")}</div>
                    <div className="col-1 d-none">{t("NRIC")}</div>
                  </div>
                  <div className="response-table w-100">
                    {customerOption.length > 0 ? (
                      customerOption.map((item, index) => {
                        return (
                          <div
                            className={`row m-0 table-body w-100 border py-2  ${
                              item.isoutlet_resrict ? "rowEnable" : "rowDisable"
                            }`}
                            onClick={() => {
                              this.props.tokenDetails.customeroutletrestrict &&
                              item.isoutlet_resrict
                                ? this.handleSelectShareCustomer(item)
                                : !this.props.tokenDetails
                                    .customeroutletrestrict
                                ? this.handleSelectShareCustomer(item)
                                : Toast({
                                    type: "error",
                                    message:
                                      "This customer is not inside your outlet, Please request this customer",
                                  });
                            }}
                            key={index}
                          >
                            <div className="col-2">{item.cust_name}</div>
                            <div className="col-2">{item.cust_phone2}</div>
                            <div className="col-1">{item.or_key}</div>
                            <div className="col-2">{item.cust_code}</div>
                            <div className="col-2">{item.cust_refer}</div>
                            <div className="col-3">{item.cust_email}</div>
                            <div className="col-1 d-none">{item.cust_nric}</div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center w-100">
                        {t("No Data are available")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className="col-4">
            <h6>Shared list of Customers:</h6>
            <div>
              <TableWrapper headerDetails={shareHeaderDetails}>
                {sharedCustomerList?.length > 0
                  ? sharedCustomerList?.map((list) => {
                      return (
                        <tr>
                          <td>{list.name}</td>
                          <td>{list.phone}</td>
                          <td>
                            {" "}
                            <span
                              className="icon-delete cursor-pointer"
                              onClick={() =>
                                this.handleDeleteSharePackage(list)
                              }
                            ></span>
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </TableWrapper>
            </div>

            <div className="col-12 mt-4 d-flex justify-content-end">
              <div className="col-5">
                <NormalButton
                  onClick={this.handleSharePackageConfirm}
                  label="Confirm"
                  mainbg={true}
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedCart: state.common.selectedCart,
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // getCustomer,
      getCommonApi,
      commonDeleteApi,
      commonPatchApi,
      commonCreateApi,
      commonUpdateApi,
      updateCommon,
      getBackendCommonApi,
      commonDeleteBackendApi,
    },
    dispatch
  );
};

export const ShareModal = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ShareModalClass)
);